import { IFormDocument } from 'pages/forms/interface';

export enum SessionType {
  digitalSession = 'Digital session',
  liveSession = 'LIVE session',
  liveClass = 'LIVE class',
  course = 'Course',
  content = 'Content only',
}

export enum CurrencyTypes {
  usd = 'USD',
  aud = 'AUD',
  gbp = 'GBP',
}

export enum SessionLanguages {
  english = 'English',
}

export enum LiveClassTypes {
  interactive = 'Interactive',
  streaming = 'Streaming',
}

export enum CourseTypes {
  lsm = 'lms',
  interactive = 'interactive',
}

export enum SessionAudienceTypes {
  public = 'public',
  private = 'private',
  subscription = 'subscription',
  subscriptionOnly = 'subscription only',
  courseOnly = 'course only',
}

export enum SessionFrequencyTypes {
  oneTime = 'One time',
  everyDay = 'Every Day',
  everyWeek = 'Every Week',
  everyMonth = 'Every month',
}

export enum DaysOfTheWeek {
  monday = 'Monday',
  tuesday = 'Tuesday',
  wednesday = 'Wednesday',
  thursday = 'Thursday',
  friday = 'Friday',
  saturday = 'Saturday',
  sunday = 'Sunday',
}

export interface ITime {
  from: string | null;
  to: string | null;
}

export interface ISessionForm {
  id: string;
  submission: string;
}
export interface ISessionFormDataItem extends IFormDocument {
  submission: string;
}
export interface IAvailableTime {
  day: string;
  isAvailable: boolean;
  isAllDay: boolean;
  times: ITime[];
  classes: IClass[];
}
export interface IClass {
  from: string;
  to: string;
  date: string;
}
export interface IFrequency {
  frequency: string;
  startDate: string;
  endDate: string;
  startAt: string;
  endAt: string;
  dayOfTheWeek: string;
  dayOfTheMonth: string;
  classes?: IClass[];
}
export interface IBadge {
  badgeTitle: string;
  badgeDescription: string;
  badgeImgUrl: string;
}

export interface IModule {
  id?: string;
  name: string;
  description: string;
  session: string[];
  sessionList?: ISessionListItem[];
  form: ISessionForm[];
  formList?: any[];
  content: string[];
  contentList?: any[];
  badge: IBadge;
  isDeleted?: boolean;
  deletedAt?: string;
  version?: number;
  isUpdated?: boolean;
}

export interface IWaitingMedia {
  fileName: string;
  contentUrl: string;
  thumbnailUrl: string;
  fileType: string;
}

export interface IContentItemData {
  id: string;
  info: {
    title: string;
    thumbnailUrl: string;
  };
  url: string;
  fileType: string;
  action: {
    id: string;
    isAdded: boolean;
  };
}

export interface ISessionMeta {
  liveClassType: string;
  startDate: string;
  endDate: string;
}
export interface IInvitedParticipants {
  firstName: string;
  email: string;
}
export interface SessionDocument {
  _id: string;
  title: string;
  isActive: boolean;
  nextSession: string;
  sessionType: string;
  bookedSessions: number;
  availableSessions?: number;
  bookedObservers?: number;
  availableParticipants?: number;
  availableObservers?: number;
}

export interface ISessionTypeModalForm {
  sessionType: string;
}
export interface IGroupItemData {
  id: string;
  title: string;
  bannerImgUrl: string;
  groupType: string;
}
export interface IFilteredGroupData {
  result: IGroupItemData[];
  total: number;
}
export interface ISessionListItem {
  id: string;
  title: string;
  sessionType: string;
  expertId: string;
  isActive: boolean;
  forms: [];
  media: [];
  modules: IModule[];
  audienceType?: string;
  bookedSessions?: number;
  availableSessions?: number;
  bookedObservers?: number;
  availableParticipants?: number;
  availableObservers?: number;
  sessionMeta?: ISessionMeta;
  deleted?: boolean;
  deletedAt?: string;
  assignedGroups?: {
    id: string;
    groupType: string;
    title: string;
  }[];
}
export interface IFilteredSessionData {
  result: ISessionListItem[];
  total: number;
}
export interface SessionBookedItemData {
  id: number;
  name: string;
  type: string;
  role: string;
}

export interface ICourseGoal {
  title: string;
}

export interface ITimeSlot {
  start: string;
  end: string;
}
export interface IRelatedSkill {
  id: string;
  name: string;
}
